import NotifyUserPage from './NotifyUserPage'

export default NotifyUserPage;